var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play-store_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.884 25.362L20.143 15.095a.783.783 0 00-.76.007.714.714 0 00-.38.626s.008.947.015 2.505L32.67 31.32l6.214-5.957z",
    fill: "url(#play-store_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.018 18.233c.023 5.622.091 19.269.122 26.063l13.537-12.977-13.659-13.086z",
    fill: "url(#play-store_svg__paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.61 31.239l-10.727-5.877-6.221 5.957 7.02 6.729 9.936-5.55a.723.723 0 00.38-.625.733.733 0 00-.388-.634z",
    fill: "url(#play-store_svg__paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.132 44.296c.015 2.425.022 3.976.022 3.976 0 .262.145.502.38.626a.783.783 0 00.76 0l19.394-10.843-7.019-6.729-13.537 12.97z",
    fill: "url(#play-store_svg__paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store_svg__paint0_linear",
    x1: 19.003,
    y1: 23.163,
    x2: 38.887,
    y2: 23.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5BBC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB96A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store_svg__paint1_linear",
    x1: 19.015,
    y1: 31.268,
    x2: 32.669,
    y2: 31.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45AFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store_svg__paint2_linear",
    x1: 32.669,
    y1: 31.71,
    x2: 49.996,
    y2: 31.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA51A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#FAB716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#FAC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC80F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "play-store_svg__paint3_linear",
    x1: 19.135,
    y1: 40.161,
    x2: 39.688,
    y2: 40.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7515B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "play-store_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(19 15)",
    d: "M0 0h31v34H0z"
  })))));
}
var MemoSvgPlayStore = /*#__PURE__*/React.memo(SvgPlayStore);
export default "data:image/svg+xml;base64,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";
export { MemoSvgPlayStore as ReactComponent };